module.exports = __webpack_public_path__ + "static/media/2.MK 12 Diesel Operated.1f6770f1.jpg";